import { OACData } from '@/modules/pipelines/model/oac-data';
import dayjs from 'dayjs';
import { useRef, useState } from 'react';
import { FormSelect } from 'react-bootstrap';
import OACChartPane from './oac-chart-pane';

export default function OACDisplay({ oacData }: { oacData: OACData[] }) {
  const [type, setType] = useState('rec');
  const skipNext = useRef(false);

  const order = ['Timely', 'Evening', 'Intraday 1', 'Intraday 2', 'Intraday 3', 'Final'];
  const oacHistory = oacData.sort((a, b) => {
    if (a.gasDay !== b.gasDay) return a.gasDay > b.gasDay ? 1 : -1;

    return order.indexOf(a.cycle) - order.indexOf(b.cycle);
  });

  const oacLabels = oacHistory.map(h => `${h.cycle}, ${dayjs(h.gasDay).utc().format('MMM Do')}`);

  if (oacLabels.length !== new Set(oacLabels).size)
    return (
      <>
        <FormSelect
          onClick={e => e.stopPropagation()}
          onChange={e => setType(e.target.value)}
          size="sm"
        >
          <option value="rec" key="rec">
            Receipt
          </option>
          <option value="del" key="del">
            Delivery
          </option>
        </FormSelect>

        <div className="d-flex flex-wrap" onClick={e => e.stopPropagation()}>
          <OACChartPane
            oacHistory={oacHistory.filter((oac, i) => {
              const isNotLast = i < oacHistory.length - 1;
              const isSameCycle = isNotLast && oac.cycle === oacHistory[i + 1].cycle;

              if (isSameCycle) {
                if (oac.flowDir === (type === 'rec' ? 'D' : 'R')) return false;
                else skipNext.current = true;
              } else if (skipNext.current) {
                skipNext.current = false;
                return false;
              }

              return true;
            })}
          />
        </div>
      </>
    );

  return (
    <div className="d-flex flex-wrap" onClick={e => e.stopPropagation()}>
      <OACChartPane oacHistory={oacHistory} />
    </div>
  );
}
